<!-- eslint-disable import/no-cycle -->
<template>
  <section>
    <h1>Lojas</h1>
    <b-button :to="{ name: 'stores-edit' }">
      Criar novo negócio
    </b-button>
    <h5 />
    <b-table
      ref="refUserListTable"
      class="position-relative"
      :items="stores"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
    >

      <!-- Column: Role -->
      <template #cell(notifications)="data">
        <div class="text-nowrap">
          <feather-icon
            :icon="resolveUserRoleIcon(data.item.notifications)"
            size="18"
            class="mr-50"
            :color="colorRoleIcon(data.item.notifications)"
          />
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <a
          v-b-modal.modal-prevent-closing
          @click="getStore(data.item)"
        ><feather-icon
          v-b-tooltip.hover.bottom="'Informações de integração'"
          variant="warning"
          icon="AlertCircleIcon"
        /></a>
        <a
          v-b-modal.modal-edit-store
          @click="getStore(data.item.uuid, data.item)"
        ><feather-icon
          v-b-tooltip.hover.bottom="'Edite sua loja'"
          variant="warning"
          icon="Edit2Icon"
        /></a>
      </template>
    </b-table>

    <!-- modal -->
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Dados de Integração"
      ok-only
      ok-title="Fechar"
    >
      <h5>Segue a baixo as instruções necessárias para a sua integração: </h5>
      <h6 v-if="platform_id === 3">
        -> Por favor, clique no botão "copiar" e logo a pós abra um chamado na Magazord com a mensagem copiada.
      </h6>
      <!--- Solução temporaria para exibição dos dados de integração -->
      <b-form-textarea
        id="textarea-auto-height"
        v-model="text"
        placeholder="Auto height textarea"
        rows="3"
        max-rows="20"
        disabled
      />
      <br>
      <!-- button -->
      <b-button
        v-clipboard:copy="text"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="success"
      >
        Copiar
      </b-button>

    </b-modal>

    <!-- modal EDITAR LOJA -->
    <b-modal
      id="modal-edit-store"
      ref="my-modal"
      title="Sua Loja"
      ok-only
      ok-title="Fechar"
    />
  </section>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BFormTextarea,
  BBadge, BDropdown, BDropdownItem, BPagination, BModal, BAlert, BInputGroup, BInputGroupPrepend, BForm, BFormGroup, VBTooltip,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import stores from '../../functions/basics/stores'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BModal,
    BAlert,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    VBTooltip,
    BFormTextarea,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      text: '',
      store: null,
      stores,
      platform_id: null,
      tableColumns: [
        { key: 'name', label: 'Nome', sortable: true },
        { key: 'actions', label: 'Ações', sortable: true },
      ],
      uuid: null,
      instructions: {
        1: {
          text: '',
          scripts: [
            'https://scripts.manyconvert.com/script/',
            '',
            '',
          ],
          platform: '',
        },
        2: {},
        3: [
          'Olá, \npor favor, realizar a integração com a ManyConvert. \n',
          '\nwebhook: https://app.manyconvert.com/api/postacks/magazord/#user/#uuid \n',
          '\nscript para a página checkout/cart: https://scripts.manyconvert.com/scripts/magazord/abandonedCart.js\n',
          '\nscript para a página checkout/payment: https://script.manyconvert.com/scripts/magazord/manyConvertCheckout.js\n',
          '\nscript para a página /login e checkout/identify: https://script.manyconvert.com/scripts/magazord/manyConvertIdentify.js\n',
        ],
        4: {},
        5: {},
        6: {},
        7: {},
        8: {},
      },
      teste: null,
    }
  },
  async mounted() {
    this.stores = await stores()
  },
  methods: {
    getStore(store) {
      this.text = ''
      this.uuid = store.uuid
      this.platform_id = store.sale_platform_id

      for (const instruction of this.instructions[store.sale_platform_id]) {
        this.text += instruction.replace('#uuid', store.uuid).replace('#user', store.user_id)
      }
    },
    onCopy() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Mensagem copiada!',
          icon: 'BellIcon',
          text: 'Por favor, abra um chamado na sua plataforma para finalizar sua integração.',
        },
      })
    },
    onError() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Failed to copy texts!',
          icon: 'BellIcon',
        },
      })
    },
  },
}
</script>
